import { removeUserFromLocalStorage } from "../utils/functions/localStorageManager";
import { loadingState, loadingText } from "../states/loadingState";
import { userState } from "../states/userState";
import { useSetRecoilState, useRecoilState, useResetRecoilState } from "recoil";
import { useState } from "react";
import { sleep } from "../utils/functions/commons";
import { useNavigate } from "react-router-dom";
import { gapi } from "gapi-script"; // Import gapi for OAuth2 sign-out
import { accessTokenState } from "../states/accessTokenState";

export const useLogoutOAuth2 = () => {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const [user, setUser] = useRecoilState(userState);
  const resetUserState = useResetRecoilState(userState);
  const resetAccessToken = useResetRecoilState(accessTokenState);
  const logout = async () => {
    setLoading(true);
    setLoadingAnimation(true);
    setLoadingText("ログアウト中...");

    // Remove user data from local storage and reset Recoil state
    removeUserFromLocalStorage();
    setUser({ ...user, isAuth: false });
    resetUserState();
    resetAccessToken();
    await sleep(100);

    // Sign out from Google OAuth2
    const authInstance = gapi.auth2.getAuthInstance();
    authInstance
      .signOut()
      .then(() => {
        setLoadingAnimation(false);
        setLoadingText("");
        setLoading(false);
        // window.location.reload();
      })
      .catch((error: any) => {
        // Handle sign-out errors here
        console.error("サインアウトエラー: ", error);
        setLoading(false);
        setLoadingAnimation(false);
        setLoadingText("");
      });
  };

  return {
    logout,
    loading,
    error,
  };
};
